module.exports = __webpack_public_path__ + "static/img/fangan5.2529b7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/fangan5.png
// module id = KjQX
// module chunks = 1